import React, {Component} from 'react';
const { connect } = require('react-redux');
import Modal from 'react-bootstrap-modal';

import ModalBecomeXXL from 'components/modals/ModalBecomeXXL';
import {Form} from 'form';

import 'sass/modals/modalAddBadProfile.scss';

import {t} from 'l10n';

import {addBadProfile} from 'backend-helpers/member';
import {profileDenounced} from '../../reducers/profile';

class ModalAddBadProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            state: 'initial'
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formData, setErrors) {
        let {user, profileDenounced} = this.props;

        addBadProfile(formData)
            .then(() => {
                profileDenounced(user.nick);
                this.setState({state: 'sent'});
            })
            .catch((error) => {
                // console.log(error);
                this.setState({state: 'error'});
            })
    }

    getInitialBody(props) {
        let {user, closeFn} = props;

        return (
            <Modal.Body>
                <div className="close" onClick={closeFn}/>
                <h1 className="modal-title">{t('Denounce %1', user.nick)}</h1>
                <p className="text">{t('Do you really want to denounce this user to the site\'s administrator?')}</p>
                <div className="form">
                    <Form onSubmit={this.onSubmit}>
                        <input type="hidden" name="id" value={user.id}/>

                        <div className="form-group">
                            <label className="mini">{t('Reason:')}</label>
                            <textarea name="comments"/>
                        </div>

                        <div className="form-group">
                            <div className="buttons">
                                <button className="block">{t('Denounce')}</button>
                                <button type="button" className="cancel" onClick={closeFn}>{t('Cancel')}</button>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
        )
    }

    getSentBody(props) {
        let {closeFn} = props;

        return (
            <Modal.Body>
                <p className="text">{t('Your information is taken into account and will be reviewed promptly by an administrator.')}</p>
                <div className="form">
                    <div className="form-group">
                        <div className="buttons">
                            <button className="close" onClick={closeFn}>{t('Close')}</button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        )
    }

    getErrorBody(props) {
        let {closeFn} = props;

        return (
            <Modal.Body>
                <p className="text">{t('You already denounced this profile.')}</p>
                <div className="form">
                    <div className="form-group">
                        <div className="buttons">
                            <button className="close" onClick={closeFn}>{t('Close')}</button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        )
    }

    render() {
        let {show, closeFn, currentUser} = this.props;

        if (!show) return null;

        if (!currentUser.isXXL()) {
            return <ModalBecomeXXL show={show} closeFn={closeFn}/>
        }

        let body;
        switch (this.state.state) {
            case 'initial': body = this.getInitialBody(this.props); break;
            case 'sent': body = this.getSentBody(this.props); break;
            case 'error': body = this.getErrorBody(this.props); break;
        }

        return (
            <Modal className="modalAddBadProfile"
                   show={show}
                   onHide={closeFn}
                   onExited={() => this.setState({state: 'initial'})}
            >
                {body}
            </Modal>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser
    }),
    {
        profileDenounced: profileDenounced
    }
)(ModalAddBadProfile);


// WEBPACK FOOTER //
// ./src/components/modals/ModalAddBadProfile.js